export default __webpack_public_path__ + "static/media/homepa.15b37d72.png";